import { useTranslation } from 'react-i18next';
import useResize from '@/hooks/useResize';
import { Box, Flex } from '@/layout';
import { ContainerWrapper, LogoPic, Title, SwiperBtn } from './style';
import { strategicPartnerGroups, supportingOrganisationLogos } from './logos';

import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';

const StrategicPartners = () => {
  // @ts-ignore
  const { t } = useTranslation();
  const { isTablet, isMobile } = useResize();

  return (
    <ContainerWrapper isMobile={isMobile}>
      <Title isTablet={isTablet} isMobile={isMobile}>
        {t('pages.index.StrageticPartners.title')}
      </Title>
      <Box position={'relative'}>
        {isTablet && (
          <>
            <SwiperBtn className="logoPrevBtn">
              <img src="/images/index/arrow_back_gray.svg" alt="" />
            </SwiperBtn>
            <Swiper
              centeredSlides={true}
              grabCursor={true}
              modules={[Navigation]}
              spaceBetween={0}
              slidesPerView={1}
              navigation={{
                prevEl: '.logoPrevBtn',
                nextEl: '.logoNextBtn',
              }}
              onSwiper={(swiper) => {}}
              onSlideChange={() => {}}
              loop={true}
              autoHeight={true}
            >
              {strategicPartnerGroups.map(({ logos }, index) => (
                <SwiperSlide key={index}>
                  <Flex gridGap={'30px'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
                    {logos.map(({ src, alt, height }) => (
                      <LogoPic key={src} src={src} alt={alt} height={height} />
                    ))}
                  </Flex>
                </SwiperSlide>
              ))}
            </Swiper>
            <SwiperBtn className="logoNextBtn">
              <img src="/images/index/arrow_forward_gray.svg" alt="" />
            </SwiperBtn>
          </>
        )}

        {!isTablet && (
          <Flex alignItems={'center'} justifyContent={'center'} flexWrap={'wrap'} gridGap={'10px'}>
            {strategicPartnerGroups.map(({ desktopGap, logos }, index) => (
              <Flex key={index} gridGap={desktopGap} justifyContent={'center'} alignItems={'center'}>
                {logos.map(({ src, alt, height }) => (
                  <LogoPic key={src} src={src} alt={alt} height={height} />
                ))}
              </Flex>
            ))}
          </Flex>
        )}
      </Box>

      <Box marginTop={40}>
        <Title isTablet={isTablet} isMobile={isMobile}>
          {t('pages.index.StrageticPartners.supportingOrganisation')}
        </Title>
        <Flex
          gridGap={'50px'}
          flexDirection={isTablet ? 'column' : 'row'}
          justifyContent={'center'}
          alignItems={'center'}
        >
          {supportingOrganisationLogos.map(({ src, alt, height }) => (
            <LogoPic key={src} src={src} alt={alt} height={height} />
          ))}
        </Flex>
      </Box>
    </ContainerWrapper>
  );
};

export default StrategicPartners;
